<template>
  <ul class="mod-image-holder">
    <li
      v-for="(photo,i) in photos"
      :key="i"
    >
      <preview-job-picture
        :photo-id="photo.id"
        :alt="photo.caption"
        :caption="photo.caption"
        v-on="$listeners"
      />
    </li>
  </ul>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
import PreviewJobPicture from '@/components/atoms/PreviewJobPicture'
export default {
  components: {
    PreviewJobPicture
  },
  props: {
    photos: {
      type: Array,
      default: () => []
    }
  }
}
</script>
